import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import "../../../Components/Notes/notes.css";
import { useDispatch, useSelector } from "react-redux";
import { setNoteNumber } from "../../../helper/calculation";
import CompareFsPattern1 from "./compareFsPattern1";
import CompareFsPattern2 from "./compareFsPattern2";
import CompareFsPattern3 from "./compareFsPattern3";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    minHeight: "50vh",
  },
  tabs: {
    maxHeight: "100vh",
    borderRight: `1px solid ${theme.palette.divider}`,
    paddingTop: "3rem",
    paddingBottom: "3rem",
    background: "linear-gradient(45deg, transparent, #E5EEEE)",
    color: "Black",
    fontSize: "1rem",
    width: "260px",
  },
  tab: {
    padding: "12px 12px",
    overflow: "hidden",
    position: "relative",
    fontSize: "5px",
    boxSizing: "border-box",
    minHeight: "55px",
    textAlign: "center",
    flexShrink: 0,
    fontWeight: "500",
    letterSpacing: "0.02857em",
    textTransform: "none",
  },
  TabPanel: {
    width: "100%",
  },
}));

export default function CompareFsBalanceNote(props) {
  const {
    consoleNotes,
    balanceSheetData,
    groupingData,
    consoleData,
    allcheckdata,
    tab,
    pnlStatementData,
    currentCompProjectId,
    checkKey,
    subsiaryData,
    bsNotes,
    standaloneGroupingData,
    FindIr
  } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const [no, setNo] = useState([]);
  const [value, setValue] = useState("");
  const [math, setMath] = useState("");
  const NoteNo = useSelector((initialState) => initialState.reducer.blNoteNo);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { loading, isSuccess, response, error_message } = balanceSheetData;
  const currentProjectBs = response?.data?.balance_sheet?.balance_sheet ?? [];
  const fsRows = Object.keys(currentProjectBs);

  useEffect(() => {
    setValue(checkKey);
    setNo(setNoteNumber(fsRows, currentProjectBs));
  }, [checkKey]);

  const getIndexNumber = (line) => {
    try {
      let index = no.findIndex(
        (note) =>
          note?.notes_grp.toLowerCase() === line?.notes_grp.toLowerCase()
      );
      return (index += 2);
    } catch (err) {
      return "00";
    }
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        className={classes.tabs}
      >
        {fsRows.map((group, groupIndex) => {
          return currentProjectBs[group].map((noteGroup, noteGroupIndex) => (
            <Tab
              className={classes.tab}
              label={
                "Note - " +
                noteGroup.notes_grp
              }
              value={Number(getIndexNumber(noteGroup))}
              {...a11yProps(noteGroupIndex)}
            />
          ));
        })}
      </Tabs>

      {Object.keys(consoleNotes).map((data, key) => (
        <div key={key}>
          {data === "pattern_1" ? (
            <>
              {consoleNotes[data].map((data, key) => (
                <TabPanel
                  key={key}
                  className={classes.tab}
                  value={value}
                  index={data.index}
                >
                  <CompareFsPattern1
                    note_no={data.note_number}
                    groupingData={groupingData}
                    rows={balanceSheetData?.balance_sheet?.balance_sheet}
                    currentCompany={consoleData}
                    subsiary={balanceSheetData?.balance_sheet?.balance_sheet}
                    sybsidiary={[
                      balanceSheetData?.balance_sheet?.balance_sheet,
                    ]}
                    finalSubsidiaryData={balanceSheetData?.project_ids_bs?.map(
                      (data) => data.balance_sheet
                    )}
                    subsiaryData={subsiaryData}
                    browsFs={[]}
                    current_tab={tab}
                    tabData={"bs"}
                    pnlStatementData={pnlStatementData}
                    currentCompProjectId={currentCompProjectId}
                    bsNotes={bsNotes}
                    standaloneGroupingData={standaloneGroupingData}
                    FindIr={FindIr}
                  />
                </TabPanel>
              ))}
            </>
          ) : data === "pattern_2" ? (
            <>
              {consoleNotes[data].map((data, key) => (
                <>
                  <TabPanel key={key} value={value} index={data.index}>
                    <CompareFsPattern2
                      note_no={data.note_number}
                      group={0}
                      groupingData={groupingData}
                      currentCompany={consoleData}
                      subsiaryData={allcheckdata}
                      currentCompProjectId={currentCompProjectId}
                      current_tab={tab}
                      tabData={"bs"}
                      bsNotes={bsNotes}
                      standaloneGroupingData={standaloneGroupingData}
                      FindIr={FindIr}
                    />
                  </TabPanel>
                </>
              ))}
            </>
          ) : data === "pattern_3" ? (
            <>
              {consoleNotes[data].map((data, key) => (
                <TabPanel key={key} value={value} index={data.index}>
                  <CompareFsPattern3
                    note_no={data.note_number}
                    groupingData={groupingData}
                    currentCompProjectId={currentCompProjectId}
                    currentCompany={consoleData}
                    subsiaryData={allcheckdata}
                    subsidiaryGrouping={
                      groupingData?.response?.data?.browse_fs_grouping ?? []
                    }
                    browsFsGrouping={
                      groupingData?.response?.data?.browse_fs_grouping ?? []
                    }
                    finalSubsidiaryData={
                      groupingData?.response?.data?.project_ids_grouping ?? []
                    }
                    pnlStatementData={pnlStatementData}
                    current_tab={tab}
                    tabData={"bs"}
                    bsNotes={bsNotes}
                    standaloneGroupingData={standaloneGroupingData}
                    FindIr={FindIr}
                  />
                </TabPanel>
              ))}
            </>
          ) : (
            ""
          )}
        </div>
      ))}
    </div>
  );
}
